module.exports = __webpack_public_path__ + "images/questions/qa_balloon_02_6adc18a6cd9c6d03b3e49a1b0991d92c.png";